/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerNew
 */
export interface PartnerNew {
    /**
     * 
     * @type {string}
     * @memberof PartnerNew
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerNew
     */
    active: boolean;
}

/**
 * Check if a given object implements the PartnerNew interface.
 */
export function instanceOfPartnerNew(value: object): value is PartnerNew {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function PartnerNewFromJSON(json: any): PartnerNew {
    return PartnerNewFromJSONTyped(json, false);
}

export function PartnerNewFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerNew {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'active': json['active'],
    };
}

export function PartnerNewToJSON(json: any): PartnerNew {
    return PartnerNewToJSONTyped(json, false);
}

export function PartnerNewToJSONTyped(value?: PartnerNew | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'active': value['active'],
    };
}

